import configureAppStore from './configureAppStore'

// No argument passed to the function as no preloadedState yet...
const store = configureAppStore()

export default store
